import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import NoSleep from 'nosleep.js'

let noSleep = new NoSleep()
document.addEventListener(
  'click',
  function enableNoSleep() {
    document.removeEventListener('click', enableNoSleep, false)
    noSleep.enable()
  },
  false
)

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)